import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';
import {
  WebhookEventDetailResponse,
  WebhookEventResponse,
} from '../../Interfaces/api/backoffice/webhook-event.interface';

export class WebhookEvent {
  id = '';
  stripe_event_id: string | null = null;
  event_type: string | null = null;
  livemode = false;
  processing_status = '';
  attempts = 0;
  received_at: string | null = null;
  processed_at: string | null = null;
  is_replayable = false;
  payload: unknown = null;
  error_message: string | null = null;

  constructor(data: Partial<WebhookEventDetailResponse | WebhookEventResponse> = {}) {
    Object.assign(this, data);
  }

  get statusTone(): StatusTone {
    if (this.processing_status === 'processed') {
      return 'positive';
    }

    if (this.processing_status === 'failed') {
      return 'danger';
    }

    if (this.processing_status === 'received') {
      return 'warning';
    }

    return 'neutral';
  }

  get hasPayload(): boolean {
    return this.payload !== null && this.payload !== undefined;
  }

  get payloadJson(): string {
    return this.hasPayload ? JSON.stringify(this.payload, null, 2) : '';
  }
}
